import React, { useRef } from 'react';

// Draw-to-sign pad – shown over the signer when a signature field is tapped.
// Emits a PNG data URL via onDone (used as the flattened signature image).
// Extracted so the full-page PdfSignPage and the (legacy) modal can share it.
const FONT = "font-['Metropolis']";

export default function SignatureCapture({ onDone, onCancel }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);
  const dirty = useRef(false);
  const point = (e) => { const c = canvasRef.current; const r = c.getBoundingClientRect(); const s = e.touches?.[0] || e; return { x: (s.clientX - r.left) * (c.width / r.width), y: (s.clientY - r.top) * (c.height / r.height) }; };
  const start = (e) => { e.preventDefault(); drawing.current = true; last.current = point(e); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const p = point(e); const g = canvasRef.current.getContext('2d'); g.strokeStyle = '#131313'; g.lineWidth = 2.4; g.lineCap = 'round'; g.lineJoin = 'round'; g.beginPath(); g.moveTo(last.current.x, last.current.y); g.lineTo(p.x, p.y); g.stroke(); last.current = p; dirty.current = true; };
  const end = () => { drawing.current = false; };
  const clear = () => { const c = canvasRef.current; c.getContext('2d').clearRect(0, 0, c.width, c.height); dirty.current = false; };
  return (
    <div className="fixed inset-0 z-[80] bg-black/50 flex items-center justify-center p-4" onClick={onCancel}>
      <div className="bg-white rounded-2xl shadow-lift p-5 w-full max-w-[560px]" onClick={e => e.stopPropagation()}>
        <div className={`${FONT} text-[13px] font-bold text-ink mb-2`}>Draw your signature</div>
        <canvas ref={canvasRef} width={560} height={170}
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end}
          className="w-full bg-white border border-line rounded-lg cursor-crosshair" style={{ height: 170, touchAction: 'none' }} />
        <div className="flex items-center justify-between mt-3">
          <button type="button" onClick={clear} className={`${FONT} text-[11px] font-semibold text-[#2E8FA1] hover:underline`}>Clear</button>
          <div className="flex items-center gap-3">
            <button type="button" onClick={onCancel} className={`${FONT} text-[11px] font-bold uppercase tracking-[0.15em] text-[#51534A]`}>Cancel</button>
            <button type="button" onClick={() => { if (dirty.current) onDone(canvasRef.current.toDataURL('image/png')); }}
              className={`${FONT} text-[11px] font-bold uppercase tracking-[0.15em] text-white bg-[#2E8FA1] rounded-full px-5 py-2 hover:brightness-110`}>Use signature</button>
          </div>
        </div>
      </div>
    </div>
  );
}
